import { useContext, useEffect, useState } from "react";
import { AlertContext } from "../../contexts/AlertContext";
import { LoaderContext } from "../../contexts/LoaderContext";
import { SocketContext } from "../../contexts/SocketContext";
import { useSedes } from "../useSedes";

export const useTramits = (sedeId) => {

    const [tramits, setTramits] = useState([]);

    const { alertRef } = useContext(AlertContext);
    const { socket } = useContext(SocketContext);
    const { setOpenLoader } = useContext(LoaderContext);
    const { sede } = useSedes(sedeId);

    useEffect(() => {
        let unsubscribed = true;

        const handleGetTramites = () => socket.emit('frontend:obtener-tramites', { }, response => {
            setOpenLoader(true);
            const { ok, message, data } = response;

            if(!ok) {
                setOpenLoader(false);
                alertRef.current.handleOpen('error', message);
                return;
            }

            setTramits(data.filter(tramite => tramite?.sedes?.includes(sede?.nombre)));
            setOpenLoader(false);
        });

        unsubscribed && handleGetTramites();

        return () => {
            unsubscribed = false;
            socket.off('frontend:obtener-tramites');
        };
    }, [sede]);

    const extractTramits = () => {
        return tramits.map(tramit => tramit.abreviacion);
    }

    return {
        tramits,
        extractTramits
    }
}